"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UpdateBanner_1 = __importDefault(require("./UpdateBanner"));
exports.default = UpdateBanner_1.default;
